module.exports = __webpack_public_path__ + "static/media/156.ae138e3a.jpg";